(ns hai.home.mobile.mini-apps.tips-and-tricks
  "Tips and tricks mini-app card for the mobile dashboard: the same \"Humble
   setup\" checklist and ⋮ actions as the desktop card
   ([[hai.home.tips-and-tricks]]), led by a mobile-only step — taking the
   onboarding tour, a way back into it for anyone who closed it early or wants
   it again. Header in system gray, as there: this is Humble's own card, not
   one of the user's apps."
  (:require
   [hai.entity.kebab :as kebab]
   [hai.home.mobile.mini-apps :as mini-apps]
   [hai.home.mobile.state :as state]
   [hai.home.tips-and-tricks :as tips-and-tricks]
   [hai.mini-apps.data :as mini-apps-data]
   [hai.mini-apps.frame :as frame]
   [hai.onboarding :as onboarding]
   [hai.ui.icons :as icons]
   [hai.ui.rf-sugar :refer [<s >e]]
   [hai.ui.tokens :as t]
   [lambdaisland.ornament :as o]))

(def ^:private lightbulb-icon (icons/mui-icon :outlined :lightbulb))

;; The tour step's label opens the tour.
(def ^:private steps
  (mapv (fn [{:keys [key] :as step}]
          (cond-> step
            (= key :onboarding.step/mobile-tour)
            (assoc :on-click #(>e [::state/open-onboarding]))))
        onboarding/mobile-steps))

(o/defstyled card mini-apps/card
  [:.app-header {:background t/--system}]
  ;; :lightbulb is a Material fill icon, unlike the stroke icons the shared card
  ;; frame assumes, so restore fill and match the other header icons' size.
  [:.app-icon [:svg {:fill "currentColor" :width "20px" :height "20px"}]]
  [:.tips-body {:padding "14px 16px 16px"}])

(defn panel [{title :mini-app/title}]
  (let [collapsed? @(<s [::mini-apps-data/collapsed? :tips-and-tricks])]
    [card {:class (when collapsed? "collapsed")}
     [:div.app-header
      [:span.app-icon [lightbulb-icon]]
      [:h2.app-title title]
      [:div.app-actions
       [frame/collapse-toggle
        {:collapsed? collapsed?
         :label      "tips and tricks"
         :class      "app-action-btn"
         :on-toggle  #(>e [::mini-apps-data/toggle-collapsed :tips-and-tricks])}]
       [kebab/menu
        {:actions    (tips-and-tricks/menu-actions steps)
         :aria-label "Tips and tricks actions"}]]]
     (when-not collapsed?
       [:div.tips-body
        [tips-and-tricks/setup-checklist steps]])]))
